import { Component, Inject, OnInit } from '@angular/core';
import { LoaderService } from './loader/loader.service';
import { EnvironmentService } from './environment.service';
import { TranslateService } from '@ngx-translate/core';
import defaultLanguage from './../assets/i18n/en.json';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  loader = false;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  signUp = false;

  constructor(
    private readonly loaderService: LoaderService,
    private readonly envServiceProvider: EnvironmentService,
    public translate: TranslateService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    translate.setTranslation('en', defaultLanguage);
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.loaderService.status.subscribe((val: boolean) => {
      this.loader = val;
    });
    this.loaderService.signUp.subscribe((val: boolean) => {
      this.signUp = val;
    });
    this.envServiceProvider.config({
      domains: {
        local: ['localhost'],
        uat: ['waui.hrx.one'],
        live: ['xwaui.hrx.one'],
      },
      vars: {
        local: {
          appName: 'unifiedai',
          vCardFile: 'unifiedai.vcf',
          // apiUrl: 'https://staging-unifiedai-api.unificationengine.com/console',
          // socketUrl: 'https://staging-unifiedai-api.unificationengine.com',
          // apiUrl: 'https://waapi.hrx.one',
          // socketUrl: 'https://waapi.hrx.one',
          apiUrl: 'https://192.168.2.2:7676',
          socketUrl: 'https://192.168.2.2:7676',
          connectorUrl: 'https://beta-unifiedai-test-agent-chatbot-v2connector.unificationengine.com/',
          apiUrlCount: 7,
          Authorization: 'aZ2ZmJ6wKfKtgcvD',
          statusKey: 'C7646E98438F7FC2AD6C2717DFE9D',
          smartContactImage: [
            { url: 'uiblogo-smart.png', height: ' 50px', margin: '30px' },
          ],
          clientId: '221460181203789',
          redirectUrl: 'https://waapi.hrx.one/callback/fb/auth',
          tiktok_redirectURL: 'https://beta-partner-portal-api.unificationengine.com/callback/tiktok/auth/',
          tiktokAppId: '7481464809368584193',
          tiktokAds_redirectURL: 'https://staging-unifiedai-api.unificationengine.com/console/callback/tiktok/advertiser/auth/',
          ssoEnabled: true,
        },
        uat: {
          appName: 'unifiedai',
          vCardFile: 'unifiedai.vcf',
          apiUrl: 'https://waapi.hrx.one',
          socketUrl: 'https://waapi.hrx.one',
          // apiUrl: 'http://192.168.2.2:7676',
          // socketUrl: 'http://192.168.2.2:7676',
          connectorUrl: 'https://beta-unifiedai-test-agent-chatbot-v2connector.unificationengine.com/',
          apiUrlCount: 7,
          Authorization: 'aZ2ZmJ6wKfKtgcvD',
          statusKey: 'C7646E98438F7FC2AD6C2717DFE9D',
          smartContactImage: [
            { url: 'uiblogo-smart.png', height: ' 50px', margin: '30px' },
          ],
          clientId: '221460181203789',
          redirectUrl: 'https://waapi.hrx.one/callback/fb/auth',
          tiktok_redirectURL: 'https://beta-partner-portal-api.unificationengine.com/callback/tiktok/auth/',
          tiktokAppId: '7481464809368584193',
          tiktokAds_redirectURL: 'https://staging-unifiedai-api.unificationengine.com/console/callback/tiktok/advertiser/auth/',
          ssoEnabled: true,
        },
        live: {
          appName: 'unifiedai',
          vCardFile: 'unifiedai.vcf',
          apiUrl: 'https://xwaapi.hrx.one',
          socketUrl: 'https://xwaapi.hrx.one',
          // apiUrl: 'http://192.168.2.2:7676',
          // socketUrl: 'http://192.168.2.2:7676',
          connectorUrl: 'https://beta-unifiedai-test-agent-chatbot-v2connector.unificationengine.com/',
          apiUrlCount: 7,
          Authorization: 'aZ2ZmJ6wKfKtgcvD',
          statusKey: 'C7646E98438F7FC2AD6C2717DFE9D',
          smartContactImage: [
            { url: 'uiblogo-smart.png', height: ' 50px', margin: '30px' },
          ],
          clientId: '221460181203789',
          redirectUrl: 'https://xwaapi.hrx.one/callback/fb/auth',
          tiktok_redirectURL: 'https://beta-partner-portal-api.unificationengine.com/callback/tiktok/auth/',
          tiktokAppId: '7481464809368584193',
          tiktokAds_redirectURL: 'https://staging-unifiedai-api.unificationengine.com/console/callback/tiktok/advertiser/auth/',
          ssoEnabled: true,
        },
      },

    });
    this.envServiceProvider.check();
  }
  loadStyle(styleName: string) {
    const head = this.document.getElementsByTagName('head')[0];
    const themeLink = this.document.getElementById(
      'client-theme'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}`;
      head.appendChild(style);
    }
  }
}

